import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExcelDownload = ({ data, fileName }) => {
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      alert("No data to export!");
      return;
    }

    // Define column headers
    const headers = [
      ["Application No", "First Name", "Last Name", "Status"]
    ];

    // Format data for Excel
    const excelData = data.map((app) => [
      app.application_no,
      app.first_name,
      app.last_name,
      app.status
    ]);

    // Merge headers and data
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...excelData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

    // Generate Excel and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(dataBlob, `${fileName || "applications"}.xlsx`);
  };

  return (
    <button
      onClick={exportToExcel}
      className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4"
    >
      Download Excel
    </button>
  );
};

export default ExcelDownload;
